module.exports = __webpack_public_path__ + "img/ro.98183cb0.svg";